import _objectSpread from "E:\\Workspaces\\VScode\\vue3+TS\\vue\u6848\u4F8B\\cloudMusicProject-master\\node_modules\\@babel\\runtime\\helpers\\esm\\objectSpread2.js";
import { computed, defineComponent, reactive } from "vue";
import { useState } from "@/hooks/mapGet/index.js";
import { useStore } from "vuex";
import { changeTag } from "@/hooks/tagCate";
import PlayListHead from "@/components/play-list-head/play-list-head.vue";
import VideoList from "@/components/video-list/videoList.vue";
import Loading from "@/baseui/loading/loading.vue";
export default defineComponent({
  name: "Video",
  setup: function setup() {
    var state = useState("Video", ["tagList", "tagRList", "videoList", "errMsg"]);
    var loginState = useState("Login", ["userData"]);
    var store = useStore();
    var offsetRes = reactive({
      id: 0,
      offset: 8
    });
    var loginInfo = computed(function () {
      return loginState.userData.value;
    });
    /* 如果没登录则不请求数据 */

    if (loginInfo.value) {
      // const setTtag = ref("全部视频");
      store.dispatch("Video/getVideoTag");
      /* store.dispatch("Video/getVideoList");*/

      store.dispatch("Video/getVideoAllList"); //默认请求全部视频数据

      store.dispatch("Video/getVideoAllList", 8); //再次获取全部视频为了再次增加8条数据

      store.dispatch("Video/getVideoTageR");
    }
    /* 点击标签，请求标签下视频数据 */


    var changeTagName = function changeTagName(tag, id) {
      state.videoList.value.length = 0;
      offsetRes.offset = 0;
      offsetRes.id = id;

      if (tag === "全部视频") {
        store.dispatch("Video/getVideoAllList");
        return;
      } //请求防抖


      changeTag(function () {
        return store.dispatch("Video/getVideoList", offsetRes);
      }, tag, 700);
      scrollLoad(); //调用无限滚动
    };
    /* 无限滚动，请求下一页数据 */


    var scrollLoad = function scrollLoad() {
      if (offsetRes.id) {
        store.dispatch("Video/getVideoList", offsetRes);
      } else {
        store.dispatch("Video/getVideoAllList", offsetRes.offset);
      }

      offsetRes.offset += 8;
    };

    return _objectSpread(_objectSpread(_objectSpread({}, state), loginState), {}, {
      changeTagName: changeTagName,
      scrollLoad: scrollLoad
    });
  },
  components: {
    PlayListHead: PlayListHead,
    VideoList: VideoList,
    Loading: Loading
  }
});